<div
  style="
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  "
>
  <div style="flex-grow: 1"></div>
  <!-- Spazio flessibile per spingere il bottone a destra -->
  @if (significantEvents.length > 0) {
    <app-button
      style="margin-right: 1rem; margin-top: 1rem"
      [icon]="'download'"
      [size]="'icon-small'"
      (click)="printChart()"
    ></app-button>
  }
</div>
@if (significantEvents.length === 0 && !isLoading) {
  <div class="no-events">
    <img src="assets/imgs/undraw/undraw_no_data.svg" alt="Nessun Evento" />
    <span>Aggiungi degli eventi nella sezione Eventi Significativi</span>
  </div>
}

@if (isLoading) {
  <div class="loading-container">
    <app-loader [size]="'big'"></app-loader>
  </div>
}

<div
  [class.hidden]="significantEvents.length === 0"
  #chart
  style="height: 95%; overflow-x: auto; overflow-y: auto; white-space: nowrap"
></div>
